import { createReducer, on } from '@ngrx/store';
import { MosActions } from '@src/suite/common/store/mos/actions/mos.actions';
import { MosState } from '@src/suite/common/store/mos/models/mos.models';

const initialState: MosState = {
    clientCommand: { command: '' },
    serverCommand: { command: '' },
    currentStoryMos: null,
};
export const mosReducer = createReducer(
    initialState,
    on(
        MosActions.mosClientCommandSend,
        (state, action): MosState => ({
            ...state,
            clientCommand: { command: action.command },
        })
    ),
    on(
        MosActions.mosServerCommandSend,
        (state, action): MosState => ({
            ...state,
            serverCommand: { command: action.command },
        })
    ),
    on(
        MosActions.mosOjbClicked,
        (state, action): MosState => ({
            ...state,
            currentStoryMos: {
                mosElementId: action.mosElemntId,
                storyId: action.storyId,
            },
        })
    )
);
